import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

import { useModalSubmit } from "../../../common/useModalSubmit";

type TransferSubscriptionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (params: { userId: string }) => void | Promise<void>;
  /** Defaults to the Slack wording; platform asks for a platform user id. */
  placeholder?: string;
};
export const TransferSubscriptionModal: React.FunctionComponent<
  TransferSubscriptionModalProps
> = (props: TransferSubscriptionModalProps) => {
  const [userId, setUserId] = useState("");
  const { submitting, error, submit } = useModalSubmit(props.isOpen);
  return (
    <Modal isOpen={props.isOpen}>
      <div className="modal-header">
        <h5 className="modal-title">Transfer Subscription Ownership</h5>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <ModalBody>
        <div className="form-group">
          <label>New Owner</label>
          <input
            type="text"
            className="form-control"
            placeholder={props.placeholder ?? "mongo _id of the new owner"}
            onChange={(e) => setUserId(e.currentTarget.value)}
          />
        </div>

        {error && <div className="alert alert-danger mb-0">{error}</div>}
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-light"
          disabled={submitting}
          onClick={props.onClose}
        >
          Close
        </button>
        <button
          className="btn btn-primary"
          disabled={submitting}
          onClick={() => submit(() => props.onSubmit({ userId }))}
        >
          {submitting ? "Transferring…" : "Submit"}
        </button>
      </ModalFooter>
    </Modal>
  );
};
